import { Divider } from '@mui/material';
import React, { useEffect } from 'react';
import BottomSec from '../components/landing/BottomSec';
import MiddleSec from '../components/landing/MiddleSec';
import TopSec from '../components/landing/TopSec';
import MainLayout from '../layoutV2/MainLayout';
import { usePageTitleStore } from '../store/PageTitleStore';
import Blog from '../components/landing/Blog';
import SolarSubsidyBanner from '../components/landing/SolarSubsidyBanner';
import CompaniesLogo from '../components/landing/CompaniesLogo';

const LandingPage = () => {
  const { updateTitle } = usePageTitleStore();

  // useEffect(() => {
  //   updateTitle('Easiest way to go solar!');
  // }, []);

  return (
    <MainLayout>
      <TopSec startLink={'/start2'} />
      <Divider />
      <SolarSubsidyBanner />
      <CompaniesLogo />
      <MiddleSec startLink={'/start2'} />
      <Divider />
      <BottomSec startLink={'/start2'} />
      <Divider />
      <Blog />
    </MainLayout>
  );
};

export default LandingPage;
